import { HeartPulse, PackageCheck, Plus, ShieldCheck } from "lucide-react";
import { Badge, Button, Card, EmptyState, Skeleton } from "../components/ui";
import { useProducts } from "../data/platform-data";
import { Link } from "react-router-dom";
import { useTenantRuntime } from "../config/TenantRuntime";
import { FLOW_PRODUCT_MODULES } from "../data/flow-modules";

export function ProductsPage() {
  const { tenant, hasModule } = useTenantRuntime();
  const query = useProducts();
  if (tenant.product.commercialProductCode === "EVA_FLOW") {
    return (
      <div className="page-stack">
        <div className="notice">
          <PackageCheck size={20} />
          <div>
            <strong>Catálogo modular para parceiros</strong>
            <p>
              O núcleo de contratos e recebíveis atende produtos próprios ou de terceiros. Cada
              módulo comercial pode ser habilitado por parceiro.
            </p>
          </div>
        </div>
        <div className="product-grid">
          {FLOW_PRODUCT_MODULES.map((product) => (
            <Card key={product.module} title={product.name} description={product.description}>
              <div className="product-footer">
                <Badge tone={hasModule(product.module) ? "success" : "info"}>
                  {hasModule(product.module) ? "Habilitado" : "Disponível"}
                </Badge>
                {hasModule(product.module) && (
                  <Link className="text-link" to={product.path}>
                    Abrir módulo
                  </Link>
                )}
              </div>
            </Card>
          ))}
        </div>
      </div>
    );
  }
  if (query.isLoading) return <Skeleton className="dashboard-skeleton" />;
  if (query.error)
    return <EmptyState title="Falha ao carregar catálogo" description={query.error.message} />;

  return (
    <div className="page-stack">
      <div className="page-actions">
        <p>Catálogo versionado e independente das campanhas da EVA.</p>
        <Button>
          <Plus size={16} /> Nova versão
        </Button>
      </div>
      <div className="product-grid">
        {(query.data ?? []).map((product) => {
          const Icon = product.productType === "TELEMEDICINE" ? HeartPulse : ShieldCheck;
          return (
            <Card key={product.id}>
              <div className="product-title">
                <div className="product-icon">
                  <Icon />
                </div>
                <div>
                  <h2>{product.name}</h2>
                  <p>{product.code}</p>
                </div>
                <Badge tone={product.status === "ACTIVE" ? "success" : "warning"}>
                  {product.status} {product.activeVersion ? `v${product.activeVersion}` : ""}
                </Badge>
              </div>
              <ul className="feature-list">
                {product.productType === "FUNERAL" ? (
                  <>
                    <li>Adesão e manutenção configuráveis</li>
                    <li>Benefícios, carência e limites versionados</li>
                    <li>Titulares e dependentes por contrato</li>
                  </>
                ) : (
                  <>
                    <li>Mensalidade por vida</li>
                    <li>Provisioning independente na MobiMedical</li>
                    <li>Sem armazenamento de dados clínicos</li>
                  </>
                )}
              </ul>
              <div className="product-footer">
                <span>Regras preservadas por versão</span>
                <Button variant="secondary">Configurar</Button>
              </div>
            </Card>
          );
        })}
        <Card className="combo-card">
          <div className="product-title">
            <div className="product-icon">
              <PackageCheck />
            </div>
            <div>
              <h2>Oferta combinada</h2>
              <p>Um pedido com itens independentes</p>
            </div>
            <Badge tone="info">COMBO</Badge>
          </div>
          <p>Ativação, cancelamento, split e comissão continuam separados por produto.</p>
        </Card>
      </div>
    </div>
  );
}
